import { render, staticRenderFns } from "./Expansion.vue?vue&type=template&id=ae545ace&scoped=true"
import script from "./Expansion.vue?vue&type=script&lang=js"
export * from "./Expansion.vue?vue&type=script&lang=js"
import style0 from "./Expansion.vue?vue&type=style&index=0&id=ae545ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae545ace",
  null
  
)

export default component.exports